export { default as VehicleTypesList } from './List';
export { default as VehicleTypesCreate } from './Create';
export { default as VehicleTypesUpdate } from './Create';
export { default as VehicleTypesDetails } from './Create';